import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { ThemeProvider } from "./contexts/ThemeProvider";
import { AnimationProvider } from "./components/animation/AnimationProvider";
import "./lib/firebase"; // Import firebase config first

import App from "./App";

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root")!);

const Root = () => (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <AnimationProvider>
            <BrowserRouter>
              <Suspense fallback={<div>Loading app…</div>}>
                <App />
              </Suspense>
            </BrowserRouter>
          </AnimationProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// In development, wait for emulators to be evaluated before rendering
if (import.meta.env.DEV) {
  window.onEmulatorsEvaluated(() => {
    root.render(<Root />);
  });
} else {
  root.render(<Root />);
}
